/* ==========================================================================
   PanelRoom > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

/* Initial state */
const initialState = {
    total: 0,
    people: [],
    peopleIncrementDisabled: [],
    incrementDisabled: false
};

const setAge = (state, payload) => {
    const { peopleIndex, ageIndex, value } = payload;
    const room = [...state.people];

    room[peopleIndex].ages[ageIndex] = value;

    return room;
};

/* Reducer */
function reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_ROOM:
            return {
                ...state,
                people: action.payload.people,
                total: action.payload.total
            };
        case types.ADD_PEOPLE:
            return {
                ...state,
                people: action.payload.people,
                total: state.total + 1
            };
        case types.REMOVE_PEOPLE:
            return {
                ...state,
                people: action.payload.people,
                total: state.total - 1
            };

        case types.SET_AGE:
            return {
                ...state,
                people: setAge(state, action.payload)
            };
        case types.PEOPLE_ENABLE_INCREMENT:
            return {
                ...state,
                peopleIncrementDisabled:
                    action.payload >= 0 && action.payload < state.total
                        ? state.peopleIncrementDisabled.filter(item => item !== action.payload)
                        : state.peopleIncrementDisabled
            };
        case types.PEOPLE_DISABLE_INCREMENT:
            return {
                ...state,
                peopleIncrementDisabled:
                    action.payload >= 0 &&
                    action.payload < state.total &&
                    !state.peopleIncrementDisabled.includes(action.payload)
                        ? [...state.peopleIncrementDisabled, action.payload]
                        : state.peopleIncrementDisabled
            };
        case types.ENABLE_INCREMENT:
            return {
                ...state,
                incrementDisabled: false,
                peopleIncrementDisabled: []
            };
        case types.DISABLE_INCREMENT:
            return {
                ...state,
                incrementDisabled: true,
                peopleIncrementDisabled: [...Array(state.total).keys()]
            };

        case types.DESTROY:
        default:
            return state;
    }
}

/* Exports */
module.exports = { reducer };
